    
// const API_URL = "http://127.0.0.1:8000"; // Local development URL
const API_URL = "https://api.ke-csd.com"; // Production URL
// const API_URL = "http://192.168.1.250:8081"; // Local staging URL

export default API_URL;
    

